import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { LandingPage } from "../pages/landing/landing";
import { UserService } from "../providers/session-service/user-service";
import { MapPage } from "../pages/map/map";
import { PostsPage } from "../pages/posts/posts";
import { TeamShowcasePage } from "../pages/team-showcase/team-showcase";
import { GalleryPage } from "../pages/gallery/gallery";
import { BoutiquePage } from "../pages/boutique/boutique";
import { SponsorsPage } from "../pages/sponsors/sponsors";
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { BrowserTab } from '@ionic-native/browser-tab';
import { AngularFireAuth } from "angularfire2/auth";
import { OneSignal } from "@ionic-native/onesignal";
import { AngularFirestore } from 'angularfire2/firestore';
import { Config } from 'ionic-angular/config/config';
import { NotificationsPage } from '../pages/notifications/notifications';


@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    @ViewChild(Nav) nav: Nav;

    rootPage: any;
    notifications: any[];
    numberOfUnreadNotifications: number;
    pages: Array<{ title: string, component: any, icon: string }>;

    constructor(public platform: Platform, private alertCtrl: AlertController, private browserTab: BrowserTab, private events: Events,
        public statusBar: StatusBar, public splashScreen: SplashScreen, private af: AngularFireAuth, private config: Config,
        public userService: UserService, private iab: InAppBrowser, public db: AngularFirestore) {
        this.initializeApp();
        this.pages = [
            {
                title: 'Όλες οι ομάδες',
                component: TeamShowcasePage,
                icon: 'basketball'
            },
            {
                title: 'Ανακοινώσεις',
                component: PostsPage,
                icon: 'paper'
            },
            {
                title: 'Ειδοποιήσεις',
                component: NotificationsPage,
                icon: 'notifications'
            },
            {
                title: 'Gallery',
                component: GalleryPage,
                icon: 'images'
            },
            {
                title: 'Boutique',
                component: BoutiquePage,
                icon: 'shirt'
            },
            {
                title: 'Πού θα μας βρείτε',
                component: MapPage,
                icon: 'map'
            },
            {
                title: 'Facebook Group',
                component: HomePage,
                icon: 'logo-facebook'
            },
            {
                title: 'Οι χορηγοί μας',
                component: SponsorsPage,
                icon: 'ribbon'
            },
            {
                title: 'Σχετικά',
                component: HomePage,
                icon: 'information-circle'
            },
            {
                title: 'Aποσύνδεση',
                component: LandingPage,
                icon: 'exit'
            }
        ];
        this.platform = platform;
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();

            this.events.subscribe('user:loaded', user => {
                this.numberOfUnreadNotifications = user.numberOfUnreadNotifications;
            });

            this.db.doc('other/config').valueChanges().subscribe((dbConfig: any) => {
                if (this.config.get('appVersionCheckCode') < dbConfig.latestVersion) {
                    let alert = this.alertCtrl.create({
                        title: 'Νέα έκδοση διαθέσιμη',
                        message: 'Υπάρχει μία νέα έκδοση της εφαρμογής διαθέσιμη στο store. Παρακαλούμε ενημερώστε την εφαρμογή.',
                        enableBackdropDismiss: false,
                        buttons: [{
                            text: 'ΟΚ',
                            handler: data => {
                                this.platform.exitApp();
                            }
                        }]
                    });
                    alert.present();
                } else {
                    this.af.authState.subscribe(userAuthData => {
                        if (userAuthData) {
                            this.db.doc("users/" + userAuthData.uid).valueChanges().subscribe(user => {
                                this.userService.startSession(user);
                                this.rootPage = HomePage;
                            });
                        } else {
                            this.userService.startGuestSession();
                            this.rootPage = LandingPage;
                        }
                    });
                }
            });
        });
    }

    openPage(page) {
        let title = page.title;

        if ((title === "Boutique" || title === "Ειδοποιήσεις") && this.userService.getSessionType() === 'guest') {
            this.userService.createToast('Το χαρακτηριστικό αυτό είναι διαθέσιμο μόνο για τα μέλη του συλλόγου');
        } else if (title === 'Facebook Group') {
            let fbPageURL = 'https://www.facebook.com/NavarxosVotsisBC';
            if (this.platform.is('core') || this.platform.is('mobileweb')) {
                window.open(fbPageURL);
            } else {
                this.browserTab.isAvailable().then((isAvailable: boolean) => {
                    if (isAvailable) {
                        this.browserTab.openUrl(fbPageURL);
                    } else {
                        this.iab.create(fbPageURL);
                    }
                });
            }
        } else if (title === "Aποσύνδεση") {
            this.af.auth.signOut();
            this.userService.clearSession();
            this.notifications = [];
            this.nav.setRoot(page.component);
            
        } else if (title === "Σχετικά") {
            let alert = this.alertCtrl.create({
                title: 'Έκδοση ' + this.config.get('appVersion'),
                message: '<h6>Created by: John Fanidis</h6>Για οποιαδήποτε απορία σχετικά με την εφαρμογή ή πρόταση για βελτίωση, μη διστάσετε να επικοινώνησετε στο johnfanidis@gmail.com.',
                buttons: [
                    {
                        text: 'Κλεισιμο'
                    }
                ]
            });
            alert.present();
        } else {
            this.nav.push(page.component);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts